module.exports = __webpack_public_path__ + "img/cc.6cae8303.svg";